import PropTypes from "prop-types";
import React, { useEffect, useState } from "react"
import { Row, Col, CardBody, Card, Progress } from "reactstrap"
import { withRouter, Link } from "react-router-dom";

import { connect } from "react-redux";
import { getProfile } from '../../store/auth/profile/actions';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import Odometer from 'react-odometerjs';//Import Components
import LineChart from "./line-chart";
import RevenueChart from "./revenue-chart";
import SalesAnalytics from "./sales-analytics";
import DeviceAnalytics from "./devices";
import Products from "./product";
import LatestTransaction from "./latest-transaction";

//Import Image
import Revenue from './Revenue';
import { get } from "../../helpers/api_helper";
import Utils from "../Utility";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import "../../assets/css/odometer-theme-default.css"
const { io } = require("socket.io-client");

const Dashboard = (props) => {
  const { user } = props;
  const [data, setData] = useState(undefined);
  const [screens, setScreens] = useState([]);
  const [ramCounter, setRamCounter] = useState(0);
  const [time, setTime] = useState(1);
  const [users, setUsers] = useState(null);
  const [cities, setCities] = useState([]);
  const [devices, setDevices] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false)

  useEffect(() => {
    // console.log('props on home ', user);
    if (user) {
      getData();
    }
  }, [user]);

  // const getStats = () => {
  //   // console.log('calling get stat');
  //   if (!loading) {
  //     setLoading(true);
  //     get("/screen/stat", { token: user?.token })
  //       .then(json => {
  //         setLoading(false);
  //         console.log('response from get stat', json);
  //         if (json?.statusCode == 200) {
  //           json?.data?.screens.sort((a, b) => {
  //             return b.count - a.count;
  //           });
  //           setScreens(json?.data?.screens);
  //           delete json?.data?.screens;
  //           setData(json?.data);
  //           // setCities(json?.data?.userByCity);
  //           // setDevices(json?.data?.devices);
  //           // setProducts(json?.data?.products);
  //           // setUsers(json?.data?.users);
  //           const socket = io(Utils.API_URL + "/ram", { transports: ["websocket"], upgrade: false, secure: true, rejectUnauthorized: false });
  //           socket.on("get", (res) => {
  //             console.log('socket on list', res);
  //             if (res?.statusCode == 200) {
  //               // console.log(res?.data)
  //               setRamCounter(res?.counter?.english);
  //             }
  //           });
  //           socket.on("connect", (socket2) => {
  //             console.log('socket connect', socket2);
  //             socket.emit("list", { auth: user?.token });
  //           });
  //         } else {
  //           toast.error(json?.error);
  //         }
  //       })
  //       .catch(error => {
  //         setLoading(false);
  //         console.error('Error while getting stat', error);
  //         toast.error(error);
  //       });
  //   }
  // }

  const getData = () => {
    if (!loading) {
      setLoading(true);
      get("/stat", { token: user?.token })
        .then(res => {
          setLoading(false);
          if (res?.statusCode == 200) {
            setData(res?.data);
          }
        })
        .catch(err => {
          setLoading(false);
          toast.error("Something Went Wrong!");
        })
    }
  }
  console.log("get stat count data========>", data);

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader visible={loading} />
        <Row>
          <div className="col-12">
            <div className="page-title-box d-flex align-items-center justify-content-between">
              <h4 className="page-title mb-0 font-size-18"></h4>

              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active"></li>
                </ol>
              </div>

            </div>
          </div>
        </Row>
        {/* <Row style={{ justifyContent: 'right' }}>
          <Col lg={2}>
            <div style={{ width: '100%' }}>
              <AvForm stye={{ float: 'right' }}>
                <AvField
                  type="select"
                  name="time"
                  label={"Time"}
                  value={time}
                  onChange={(e) => setTime(e.target.value)}
                >
                  <option value={1}>Today</option>
                  <option value={2}>Yesterday</option>
                  <option value={7}>Last 7 Days</option>
                  <option value={15}>Last 15 Days</option>
                  <option value={30}>Last 30 Days</option>
                  <option value={180}>Last 6 Month</option>
                  <option value={365}>Last 1 Year</option>
                </AvField>
              </AvForm>
            </div>
          </Col>
        </Row> */}
        {/* <Row className="mt-2">
          <Col lg={12}>
            <LineChart data={screens} />
          </Col>
        </Row> */}
        <Row className="text-section">
          <Col lg={4}>
            <Card style={{ height: '87%' }}>
              <CardBody>
                <div className="d-flex align-items-start">
                  <div className="avatar-sm font-size-20 me-3">
                    <span className="avatar-title bg-soft-primary text-primary rounded">
                      <i className="mdi mdi-message-text"></i>
                    </span>
                  </div>
                  <div className="flex-1">
                    <div className="font-size-17 mt-2">Blogs </div>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                  <p to={{ pathname: "/users", state: { type: "Unregistered", time: "" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.unregistered?.allUsers}</h4>
                      <p style={{ fontSize: 17, color: '#000' }}><b>Tags</b></p>
                      <b style={{ fontSize: 20, color: 'blue' }}>{data?.tag}</b>
                    </div>
                  </p>
                  <p to={{ pathname: "/users", state: { type: "Unregistered", time: "" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.unregistered?.allUsers}</h4>
                      <p style={{ fontSize: 17, color: '#000' }}><b>Blog</b></p>
                      <b style={{ fontSize: 20, color: 'blue' }}>{data?.blog}</b>
                    </div>
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg={4}>
            <Card style={{ height: '87%' }}>
              <CardBody>
                <div className="d-flex align-items-start">
                  <div className="avatar-sm font-size-20 me-3">
                    <span className="avatar-title bg-soft-primary text-primary rounded">
                      <i className="mdi mdi-account-star"></i>
                    </span>
                  </div>
                  <div className="flex-1">
                    <div className="font-size-17 mt-2">Testimonials </div>
                    {/* ({data?.registered?.returnsWeekly + data?.registered?.returnsWeekly}) */}
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                  <p to={{ pathname: "/users", state: { type: "Registered", time: "Week" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.registered?.returnsWeekly}</h4>
                      <p style={{ fontSize: 17, color: '#000' }}><b>Testimonials</b></p>
                      <b style={{ fontSize: 20, color: 'blue' }}>{data?.testi}</b>
                    </div>
                  </p>
                  {/* <Link to={{ pathname: "/users", state: { type: "Unregistered", time: "Week" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.unregistered?.returnsWeekly}</h4>
                      <p style={{ fontSize: 12, color: '#000' }}>Unregistered</p>
                      <b>454</b>
                    </div>
                  </Link> */}
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg={4}>
            <Card style={{ height: '87%' }}>
              <CardBody>
                <div className="d-flex align-items-start">
                  <div className="avatar-sm font-size-20 me-3">
                    <span className="avatar-title bg-soft-primary text-primary rounded">
                      <i className="mdi mdi-account-multiple"></i>
                    </span>
                  </div>
                  <div className="flex-1">
                    <div className="font-size-17 mt-2">Clients </div>
                    {/* ({data?.registered?.returnsWeekly + data?.registered?.returnsWeekly}) */}
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                  <p to={{ pathname: "/users", state: { type: "Registered", time: "Week" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.registered?.returnsWeekly}</h4>
                      <p style={{ fontSize: 17, color: '#000' }}><b>Clients</b></p>
                      <b style={{ fontSize: 20, color: 'blue' }}>{data?.client}</b>
                    </div>
                  </p>
                  {/* <Link to={{ pathname: "/users", state: { type: "Unregistered", time: "Week" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.unregistered?.returnsWeekly}</h4>
                      <p style={{ fontSize: 12, color: '#000' }}>Unregistered</p>
                      <b>454</b>
                    </div>
                  </Link> */}
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg={4}>
            <Card style={{ height: '87%' }}>
              <CardBody>
                <div className="d-flex align-items-start">
                  <div className="avatar-sm font-size-20 me-3">
                    <span className="avatar-title bg-soft-primary text-primary rounded">
                      <i className="mdi mdi-post"></i>
                    </span>
                  </div>
                  <div className="flex-1">
                    <div className="font-size-17 mt-2">Gallery </div>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                  <p to={{ pathname: "/users", state: { type: "Unregistered", time: "" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.unregistered?.allUsers}</h4>
                      <p style={{ fontSize: 17, color: '#000' }}><b>Category</b></p>
                      <b style={{ fontSize: 20, color: 'blue' }}>{data?.cat}</b>
                    </div>
                  </p>
                  <p to={{ pathname: "/users", state: { type: "Unregistered", time: "" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.unregistered?.allUsers}</h4>
                      <p style={{ fontSize: 17, color: '#000' }}><b>Upload Photo</b></p>
                      <b style={{ fontSize: 20, color: 'blue' }}>{data?.upload_img}</b>
                    </div>
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg={4}>
            <Card style={{ height: '87%' }}>
              <CardBody>
                <div className="d-flex align-items-start">
                  <div className="avatar-sm font-size-20 me-3">
                    <span className="avatar-title bg-soft-primary text-primary rounded">
                      <i className="mdi mdi-account-question"></i>
                    </span>
                  </div>
                  <div className="flex-1">
                    <div className="font-size-17 mt-2">Inquery </div>
                    {/* ({data?.registered?.returnsWeekly + data?.registered?.returnsWeekly}) */}
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                  <p to={{ pathname: "/users", state: { type: "Registered", time: "Week" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.registered?.returnsWeekly}</h4>
                      <p style={{ fontSize: 17, color: '#000' }}><b>Contact Us</b></p>
                      <b style={{ fontSize: 20, color: 'blue' }}>{data?.contact}</b>
                    </div>
                  </p>
                  {/* <Link to={{ pathname: "/users", state: { type: "Unregistered", time: "Week" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.unregistered?.returnsWeekly}</h4>
                      <p style={{ fontSize: 12, color: '#000' }}>Unregistered</p>
                      <b>454</b>
                    </div>
                  </Link> */}
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg={4}>
            <Card style={{ height: '87%' }}>
              <CardBody>
                <div className="d-flex align-items-start">
                  <div className="avatar-sm font-size-20 me-3">
                    <span className="avatar-title bg-soft-primary text-primary rounded">
                      <i className="mdi mdi-lightbulb-on"></i>
                    </span>
                  </div>
                  <div className="flex-1">
                    <div className="font-size-17 mt-2">Project </div>
                    {/* ({data?.registered?.returnsWeekly + data?.registered?.returnsWeekly}) */}
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                  <p to={{ pathname: "/users", state: { type: "Registered", time: "Week" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.registered?.returnsWeekly}</h4>
                      <p style={{ fontSize: 17, color: '#000' }}><b>Project</b></p>
                      <b style={{ fontSize: 20, color: 'blue' }}>{data?.project}</b>
                    </div>
                  </p>
                  {/* <Link to={{ pathname: "/users", state: { type: "Unregistered", time: "Week" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.unregistered?.returnsWeekly}</h4>
                      <p style={{ fontSize: 12, color: '#000' }}>Unregistered</p>
                      <b>454</b>
                    </div>
                  </Link> */}
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg={4}>
            <Card style={{ height: '87%' }}>
              <CardBody>
                <div className="d-flex align-items-start">
                  <div className="avatar-sm font-size-20 me-3">
                    <span className="avatar-title bg-soft-primary text-primary rounded">
                      <i className="mdi mdi-account-switch"></i>
                    </span>
                  </div>
                  <div className="flex-1">
                    <div className="font-size-17 mt-2">Teams </div>
                    {/* ({data?.registered?.returnsWeekly + data?.registered?.returnsWeekly}) */}
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                  <p to={{ pathname: "/users", state: { type: "Registered", time: "Week" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.registered?.returnsWeekly}</h4>
                      <p style={{ fontSize: 17, color: '#000' }}><b>Teams</b></p>
                      <b style={{ fontSize: 20, color: 'blue' }}>{data?.teams}</b>
                    </div>
                  </p>
                  {/* <Link to={{ pathname: "/users", state: { type: "Unregistered", time: "Week" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.unregistered?.returnsWeekly}</h4>
                      <p style={{ fontSize: 12, color: '#000' }}>Unregistered</p>
                      <b>454</b>
                    </div>
                  </Link> */}
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg={4}>
            <Card style={{ height: '87%' }}>
              <CardBody>
                <div className="d-flex align-items-start">
                  <div className="avatar-sm font-size-20 me-3">
                    <span className="avatar-title bg-soft-primary text-primary rounded">
                      <i className="mdi mdi-image-area"></i>
                    </span>
                  </div>
                  <div className="flex-1">
                    <div className="font-size-17 mt-2">Subscription </div>
                    {/* ({data?.registered?.returnsWeekly + data?.registered?.returnsWeekly}) */}
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                  <p to={{ pathname: "/users", state: { type: "Registered", time: "Week" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.registered?.returnsWeekly}</h4>
                      <p style={{ fontSize: 17, color: '#000' }}><b>Subscription</b></p>
                      <b style={{ fontSize: 20, color: 'blue' }}>{data?.subcs}</b>
                    </div>
                  </p>
                  {/* <Link to={{ pathname: "/users", state: { type: "Unregistered", time: "Week" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.unregistered?.returnsWeekly}</h4>
                      <p style={{ fontSize: 12, color: '#000' }}>Unregistered</p>
                      <b>454</b>
                    </div>
                  </Link> */}
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg={4}>
            <Card style={{ height: '87%' }}>
              <CardBody>
                <div className="d-flex align-items-start">
                  <div className="avatar-sm font-size-20 me-3">
                    <span className="avatar-title bg-soft-primary text-primary rounded">
                      <i className="mdi mdi-map-marker-radius"></i>
                    </span>
                  </div>
                  <div className="flex-1">
                    <div className="font-size-17 mt-2">Location </div>
                    {/* ({data?.registered?.returnsWeekly + data?.registered?.returnsWeekly}) */}
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                  <p to={{ pathname: "/users", state: { type: "Registered", time: "Week" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.registered?.returnsWeekly}</h4>
                      <p style={{ fontSize: 17, color: '#000' }}><b>Location</b></p>
                      <b style={{ fontSize: 20, color: 'blue' }}>{data?.location}</b>
                    </div>
                  </p>
                  {/* <Link to={{ pathname: "/users", state: { type: "Unregistered", time: "Week" } }} style={{ textDecoderation: 'none' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <h4 className="mt-4" style={{ fontSize: 18 }}>{data?.unregistered?.returnsWeekly}</h4>
                      <p style={{ fontSize: 12, color: '#000' }}>Unregistered</p>
                      <b>454</b>
                    </div>
                  </Link> */}
                </div>
              </CardBody>
            </Card>
          </Col>
          {/* <Col lg={3}>
            <DeviceAnalytics source={data?.devices} />
          </Col> */}
          {/* <Col lg={3}>
            <Card style={{ height: '87%' }}>
              <CardBody>
                <div className="d-flex align-items-start">
                  <div className="avatar-sm font-size-20 me-3">
                    <span className="avatar-title bg-soft-primary text-primary rounded">
                      <i className="mdi mdi-om"></i>
                      <img src={require("../../assets/images/om.png")} style={{ width: 40, height: 40 }} />
                    </span>
                  </div>
                  <div className="flex-1">
                    <div className="font-size-16 mt-2">Ram Counter</div>

                  </div>
                </div>
                <h4 className="mt-4" style={{ textAlign: 'center' }}>{ramCounter}</h4>
                <div style={{ fontSize: 23, display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 20 }}>
                  <Odometer value={ramCounter} format="(,dd,dd,ddd),dd" />
                </div>
                <Row>
                  <div className="col-7">
                    <p className="mb-0"><span className="text-success me-2"> 0.16% <i
                      className="mdi mdi-arrow-up"></i> </span></p>
                  </div>
                  <div className="col-5 align-self-center">
                    <Progress
                      value="62"
                      color="success"
                      className="bg-transparent progress-sm"
                      size="sm"
                    />
                  </div>
                </Row>
              </CardBody>
            </Card>
          </Col> */}
          <Col lg={6}>
            {/* <SalesAnalytics source={data?.registered?.userByCity} /> */}
            {/* <Inbox /> */}
          </Col>
          <Col lg={6}>
            {/* <Products source={data?.products} /> */}
            {/* <Inbox /> */}
          </Col>
        </Row>
        <Row>
          <Col lg={8}>
            {/* <SalesAnalytics  /> */}
          </Col>
          {/* <Col lg={4}>
            <ScatterChart />
          </Col> */}
          <Col lg={4}>
            {/* <Inbox dealers={data?.dealers} /> */}
          </Col>
        </Row>
        <Row>
          <Col lg={4}>
            {/* <Inbox moderator={data?.moderator} /> */}
            {/* <Card className="bg-primary" style={{ height: 342 }}>
              <CardBody>
                <div className="text-white">
                  <h5 className="text-white">2400 + New Users</h5>
                  <p>At vero eos et accusamus et iusto odio dignissimos ducimus</p>
                  <div>
                    <Link to="#" className="btn btn-outline-success btn-sm">View more</Link>
                  </div>
                </div>
                <Row className="justify-content-end">
                  <div className="col-8">
                    <div className="mt-4">
                      <img src={widgetImage} alt=""
                        className="img-fluid mx-auto d-block" />
                    </div>
                  </div>
                </Row>
              </CardBody>
            </Card> */}
          </Col>
          {/* <Reviews /> */}
          {/* <Revenue /> */}
        </Row>

        <Row>
          {/* <LatestTransaction user={user} history={props?.history} /> */}
        </Row>

      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  getProfile: PropTypes.func
}

const mapStateToProps = state => {
  // console.log('state at dashboard', state);
  const { user } = state.Profile;
  return { user }
}

export default withRouter(
  connect(mapStateToProps, { getProfile })(Dashboard)
)